<template>
    <div class="headerm">
        <div class="logo" v-if="company_sn=='R'"><img src="../assets/logo/logo_new.jpg" alt="" /></div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            company_sn:"R"
        }
    },
    created(){
        if(sessionStorage.getItem("company_sn")!=null){
            this.company_sn=sessionStorage.getItem("company_sn")
        }
    },
    methods:{
        handleClick(command) {
            this.company_sn=command
            sessionStorage.setItem("company_sn", command);
            this.$router.push({ path: "/home_m" });
            var t
            clearTimeout(t)
            var _that=this
            t=setTimeout(function(){
                _that.$router.go(0);
            },500
            )
    },
    }
}
</script>

<style>
.headerm{
    display: flex;
}
.logo{
    width: 80vw;
    text-align: left;
}
.logo img{
    width: 190px;
    height: 70px;
}
.xlk{
    margin: 5vw;
}
</style>